import React, { Component } from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import PriceWorksheetList from "./priceWorksheetList";
import {togglePriceWorksheetOpened} from "../../actions/priceWorksheetActions";
import {getDiscounts} from "../../api/server-api";
import LoadingSpinner from "../ui/loadingSpinner";

class PriceWorksheetView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      unmount: false
    };
  }

  componentDidMount() {
    if (!this.props.discountsReceived) {
      getDiscounts();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.priceWorksheetOpened && this.props.priceWorksheetOpened) {
      this.setState({
        unmount: true
      }, () => {
        setTimeout(() => {
          this.setState({
            unmount: false
          })
        }, 500)
      })
    }

  }

  closePriceSheetView = () => {
    this.props.togglePriceWorksheetOpened(false);
  };

  render() {

    const {fabricatorData} = this.props;

    return (
      <div className={"worksheet" + (this.props.priceWorksheetOpened ? " worksheet--opened" : "") + (this.state.unmount ? " worksheet--unmount" : "")}>
        <div className="worksheet-header">
          <h2 className="worksheet-header__title"><FormattedMessage id="shoppingCart.discountsTitle"/></h2>
          {fabricatorData.isAmericanImport ? null : (
            <p className="worksheet-header__description">
              <FormattedMessage id="shoppingCart.discountsDescription1"/> {fabricatorData.companyName} <FormattedMessage id="shoppingCart.discountsDescription2"/>
            </p>
          )}
        </div>
        <button className="ui-close ui-close--white worksheet-close" onClick={this.closePriceSheetView}/>
        <div className="worksheet-content">
          {this.props.discountsReceived ? <PriceWorksheetList/> : <LoadingSpinner/>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    priceWorksheetOpened: store.priceWorksheetState.priceWorksheetOpened,
    discountsReceived: store.priceWorksheetState.discountsReceived,
    fabricatorData: store.fabricatorState,
  };
};

export default connect(mapStateToProps, {
  togglePriceWorksheetOpened,
})(PriceWorksheetView);
